'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const styleEncapsulation = require('@zapier/style-encapsulation');
const react = require('@emotion/react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
const theme_LegacyTypography = require('../../../theme/LegacyTypography.cjs.js');
const components_display_Heading_Heading = require('../../display/Heading/Heading.cjs.js');
const components_display_Heading_HeadingLevel = require('../../display/Heading/HeadingLevel.cjs.js');
const components_navigation_Button_Button = require('../../navigation/Button/Button.cjs.js');
const components_marketing_CTA_constants = require('./constants.cjs.js');
const components_marketing_CTA_utils = require('./utils.cjs.js');
const theme_LegacyColorMap = require('../../../theme/LegacyColorMap.cjs.js');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const Styles = styleEncapsulation.labelStyles("CTATextContent", {
  root: (alignment = "left") => react.css`
    ${styleMixins_reset.boxSizing};
    text-align: ${alignment};
    @media screen and (min-width: 768px) {
      max-width: ${alignment === "center" ? "100%" : "450px"};
    }
  `,
  heading: (alignment, textColor) => react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.pageHeader4}
    color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[textColor]]};
    @media screen and (min-width: 768px) {
      ${theme_LegacyTypography.LegacyTypography.pageHeader3}
    }
    margin-bottom: ${alignment === "center" ? "10px" : "20px"};
  `,
  subHeading: (textColor) => react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.pageHeader9}
    color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[textColor]]};
    margin-bottom: 20px;
  `,
  description: (alignment, textColor) => react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.paragraph1ShortBold}
    color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[textColor]]};
    margin-bottom: ${alignment === "center" ? "30px" : "20px"};
  `,
  ctaContainer: react.css`
    ${styleMixins_reset.boxSizing};
    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: 768px) {
      & > a,
      & > button {
        width: auto;
      }
    }
  `
});
const getTextColor = (bgColor) => {
  return components_marketing_CTA_constants.TextColorMap[bgColor];
};
const getButton = (props) => {
  const btnProps = {
    children: props.ctaText,
    href: props.ctaHref,
    onClick: props.onCtaClick,
    onKeyDown: props.onCtaKeyDown,
    target: props.ctaTarget,
    "data-testid": "cta-button"
  };
  const btnColor = components_marketing_CTA_utils.getCtaBtnColor(props.bgColor, props.ctaBtnColor);
  return react.jsx(components_navigation_Button_Button.Button, Object.assign({}, btnProps, {
    // "primary-alt" no longer exists as of V8 and is now mapped to "primary"
    color: btnColor === "primary-alt" ? "primary" : btnColor,
    size: "large"
  }));
};
const CTATextContent = (props) => {
  const textColor = getTextColor(props.bgColor);
  return react.jsx(
    "div",
    { css: Styles.root(props.alignment), "data-zds": true },
    react.jsx(
      components_display_Heading_HeadingLevel.HeadingLevel,
      null,
      react.jsx(components_display_Heading_Heading.Heading, { css: Styles.heading(props.alignment, textColor) }, props.heading),
      props.subHeading && react.jsx(
        components_display_Heading_HeadingLevel.HeadingLevel,
        null,
        react.jsx(components_display_Heading_Heading.Heading, { css: Styles.subHeading(textColor) }, props.subHeading)
      )
    ),
    props.description && react.jsx("div", { css: Styles.description(props.alignment, textColor), "data-zds": true }, props.description),
    props.ctaText && (props.ctaHref || props.onCtaClick) && react.jsx("div", { css: Styles.ctaContainer, "data-zds": true }, getButton(props))
  );
};

exports.CTATextContent = CTATextContent;
//# sourceMappingURL=CTATextContent.cjs.js.map
